import React from 'react'
import { Layout } from '@brainstud/react-tbl/features/modals'
// TODO move ui
// import { Text, ButtonsGroup, Button, CircularProgress } from '@brainstud/schiphol-vtc-ui'
import styles from './QuizResults.module.css'

const QuizResults = props => (
  <Layout nospacing noclose>
    <div className={styles.base}>
      <div className={styles.header} />
      <div className={styles.content}>
        <div className={styles.progress}>
          <CircularProgress
            sqSize={182}
            strokeWidth={10}
            label={`${props.data.score}/${props.data.total}`}
            percentage={props.data.score/props.data.total*100} />
        </div>
        <Text smaller>Jouw score op de oefentoets</Text>

        <div className={styles.info}>
          <Text lead>De oefentoets van hoofdstuk {props.data.chapter} zit erop!</Text>
          <Text lead>Wil je jouw antwoorden nogmaals bekijken, ga dan terug naar de gemaakte vragen.</Text>
          <Text lead>Ben je klaar om meer te leren?<br/>Ga dan verder met het volgende hoofdstuk.</Text>
        </div>

        <div className={styles.actions}>
          <ButtonsGroup align="center">
            <Button
              onClick={props.modal.close}
              outline
              label="Bekijk mijn vragen" icon="arrow-left" iconPosition="left" />
            <Button
              to={props.data.nextTo} link
              primary label="Volgend hoofdstuk" icon="arrow-right" iconPosition="right" />
          </ButtonsGroup>
        </div>
      </div>
    </div>
  </Layout>
)

export default QuizResults
